export default __webpack_public_path__ + "static/media/4-16_E.28702b82.svg";